import { useMutation } from '@tanstack/react-query'

import { deleteOrganizationCreateRequest } from '@src/api'
import { DefaultApiDeleteOrganizationCreateRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteOrganizationCreateRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteOrganizationCreateRequestRequest) =>
      deleteOrganizationCreateRequest(axiosInstance, params),
  })
}
